import script from "./AddHotel.vue?vue&type=script&setup=true&lang=js"
export * from "./AddHotel.vue?vue&type=script&setup=true&lang=js"

import "./AddHotel.vue?vue&type=style&index=0&id=79e7746e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79e7746e"]])

export default __exports__